import { apiGet, apiGetList, apiPost, apiPut } from "services/api";

/**
 * API документов. Все ответы в новом формате { data, meta? } / { error }.
 * Список документов может быть большим — всегда используем пагинацию.
 */

export const getDocuments = (filters = {}) =>
  apiGetList("documents/documents", filters);

export const createDocument = ({ operation_id }) =>
  apiPost("documents/document", { operation_id: Number(operation_id) });

export const updateDocument = (payload) =>
  apiPut("documents/document", payload);

export const deleteDocuments = ({ docids }) =>
  apiPost("documents/delete-documents", {
    docids: docids.map((id) => Number(id)),
  });

export const conductDocuments = ({ docids }) =>
  apiPost("documents/conduct", { docids: docids.map((id) => Number(id)) });

export const unconductDocuments = ({ docids }) =>
  apiPost("documents/unconduct", { docids: docids.map((id) => Number(id)) });

export const duplicateDocument = ({ docid, newDocType }) =>
  apiPost("documents/duplicate", { docid: Number(docid), newDocType });

export const getDocItems = ({ docid, page, pageSize }) =>
  apiGetList("documents/get-docitems", { docid, page, pageSize });

export const createDocItems = ({ docitems }) =>
  apiPost("documents/create-docitems", { docitems });

export const updateDocItems = ({ docitems }) =>
  apiPut("documents/update-docitems", { docitems });

export const deleteDocItems = ({ docitemids, docid }) =>
  apiPost("documents/delete-docitems", {
    docitemids: docitemids.map((id) => Number(id)),
    docid: Number(docid),
  });

export const getItemLeftAmount = ({ itemid, docid }) =>
  apiGet("items/left-amount", { itemid, docid });

export const getItemsLeftAmount = ({ itemGroupIds, docId }) =>
  apiPost("documents/get-left-amount", {
    itemGroupIds: itemGroupIds.map((id) => Number(id)),
    docId: Number(docId),
  });

export const getPrintTemplates = (params) =>
  apiGetList("documents/templates", params);
